import type { TNotesType } from "components/Dashboard/DoctorDashboard/notes-and-forms/types";
import { getErrorDetail } from "components/utility/utils";
import { parseRawTemplateResponse } from "notes-and-forms-v2/util/convertTemplateToV2";
import { fetchOrchidAPI } from "utils/api";

/**
 *  Query meta data
 */
export default async function queryMetaData<T extends TNotesType>({
  type,
  id,
  onBehalfOf,
}: {
  type: T;
  id: number | string;
  onBehalfOf?: string;
}): Promise<T extends "note" ? NoteMetaData : FormMetaData> {
  if (!type) {
    throw new Error("need note or form type");
  }
  const res = await fetchOrchidAPI(
    // need to check undefined or null, since 0 is considered falsy value
    `/api/notes/v1/${type}s/${id}${
      onBehalfOf ? `?on_behalf_of=${onBehalfOf}` : ""
    }`,
  );
  if (!res.ok) {
    throw new Error(
      `failed to fetch metadata: ${getErrorDetail(await res.text())}`,
    );
  }

  if (type === "form") {
    const raw = await res.json();
    if (!raw) {
      return raw;
    }

    return parseRawTemplateResponse("form", raw);
  }

  return res.json();
}
